<template>
  <VDialog
      class="transportable-documents-picker-dialog content-block-style"
      position="right"
      width="1300px"
      height="100vh"
      closable
      no-padding
  >
    <template #header>
      Добавление документов в ЗТК
    </template>

    <!-- Кумулятивная загруженность фуры -->
    <div v-if="!transportOrder.isSingleSender" class="cargo-capacity-header">
      <CargoCapacity
          :vehicle="transportOrder.vehicle"
          :cargo-weight-gross="transportOrder.cargoWeightGross"
          :cargo-units-count="transportOrder.cargoUnitsCount"
          :cargo-volume="transportOrder.cargoVolume"
      />
    </div>

		<TransportableDocumentsRegistry
			selection-control="action"
			layout="fill"

			:params="registryParams"
			:transport-order="transportOrder"
			:show-context-menu-column="false"

		/>

    <template #footer>
      <VButton @click="$emit('close')">Закрыть</VButton>
    </template>
  </VDialog>
</template>

<style lang="scss">

.cargo-capacity-header {
  padding: 10px 20px;
}

</style>

<script lang="ts">
import TransportOrder         from '@/domains/TransportOrders/TransportOrder';

import TransportableDocumentsFilter  from '@/domains/TransportableDocuments/components/TransportableDocumentsRegistry/TransportableDocumentsFilter';
import TransportableDocumentsService from '@/domains/TransportableDocuments/TransportableDocumentsService';
import CargoCapacity                 from '@/domains/TransportOrders/components/CargoCapacity/CargoCapacity.vue';
import TransportableDocumentsRegistry
	from "@/domains/TransportableDocuments/components/TransportableDocumentsRegistry/TransportableDocumentsRegistry.vue";
import TransportOrdersService from "@/domains/TransportOrders/TransportOrdersService";

export default defineComponent({
  name: 'TransportableDocumentsPicker',

  components: {
    CargoCapacity,
		TransportableDocumentsRegistry,
  },

  props: {
    transportOrder: {
      type: TransportOrder,
      required: true,
    },

    /**
     * Типы документов (id из TransportableDocumentsFilter.DocumentClassOptions),
     * которыми ограничен выбор. Задаются вызывающей стороной.
     */
    documentClass: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },

  emits: ['close'],

  setup() {
    return {
      TransportableDocumentsService,
    };
  },

  data() {
    // Фильтр пикера не связан с localStorage: UI фильтра здесь нет,
    // а сохранённые фильтры реестра (например, пресет воронки Электросталь)
    // не должны ограничивать выбор документов для ЗТК
    const filter = new TransportableDocumentsFilter();

    if (this.$core.utils.isNotEmptyArray(this.documentClass)) {
      const documentClassOptions = TransportableDocumentsFilter.DocumentClassOptions
        .filter(_option => this.documentClass.includes(_option.id));

      filter.applyPreset({
        documentClass: documentClassOptions,
      });
    }

    return {
			filter,
    };
  },

	computed: {
		registryParams(): Parameters<typeof TransportOrdersService.getTransportableDocumentsPaginated>[0] {
			const params = {
				...this.filter.getRequestParams(),
				excludeIds: this.transportOrder.id ? [this.transportOrder.id] : undefined
			};

			// Забор у поставщика: везём позиции заказов только того покупателя,
			// который получает груз по этой ЗТК
			if (this.transportOrder.isReturn === true) {
				params.sender = this.transportOrder.receiver;
			}
			// Обычная ЗТК — один отправитель: показываем только его документы.
			// Отправитель проставляется ЗТК первым добавленным документом
			else if (this.transportOrder.isSingleSender === true && this.transportOrder.sender) {
				params.sender = this.transportOrder.sender;
			}
			else {
				// Для остальных типов выбор отправителем не ограничен
			}

			return params;
		}
	}
});
</script>